import { createTheme } from "@mui/material/styles";

const NAVY = "#252f38";
const ORANGE = "#f98a3c";

export const theme = createTheme({
  palette: {
    primary: { main: NAVY, contrastText: "#ffffff" },
    secondary: { main: ORANGE, contrastText: "#ffffff" },
    background: { default: "#f5f6f8" },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: "Roboto, system-ui, -apple-system, sans-serif",
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
  },
});
